<a class="card" [routerLink]="['/customer', company.customerId, company.urlFriendlyCustomerName]">
    <div class="card__logo">
        @if (showLogo) {
            <img class="card__logo-img" [src]="company.logoHref" [alt]="company.name" loading="lazy" (error)="logoFailed = true">
        } @else {
            <span class="card__initials">{{ initials }}</span>
        }
    </div>

    <div class="card__name">
        <span class="card__name-text" [title]="company.name">{{ company.name }}</span>
        @if (company.isVerified) {
            <img class="card__verified" [title]="'label.Verified' | translate" src="assets/img/common/verification-icon.svg" alt="">
        }
    </div>

    <div class="card__footer">
        <div class="card__badges">
            <span class="card__count">{{ 'label.CompanyVacancyCount' | translate : { count: company.paidAnnouncementTotal } }}</span>
            @if (company.hasActiveCvBox) {
           <svg-icon
            class="tile__company-cv-box"
            [svgClass]="'ico-cv-box'"
            src="assets/icons/cv-box-company.svg"
          ></svg-icon>
            }
        </div>
        <span class="card__link">{{ 'label.CompanyProfileView' | translate }}</span>
    </div>
</a>
